<template>
    <div v-if="options.length > 0">
        <form class="form-inline flex-nowrap" method="GET" :action="action">
            <select v-model="currentId" class="form-control form-control-sm" :name="name">
                <option :value="null">
                    {{ allItemsLabel }}
                </option>
                <option v-for="option in options" :key="option.id" :value="option.id">
                    {{ option.name }}
                </option>
            </select>

            <input
                v-for="(value, key) in queries"
                :key="key"
                type="hidden"
                :name="key"
                :value="value">

            <FilterButton
                type="submit"
                is-small
                class="ml-1"
                :label="actionLabel" />
        </form>
    </div>
</template>

<script>
import URI from 'urijs';

import FilterButton from '@/js/components/common/buttons/FilterButton';

const uri = URI(window.location.href);
const queryMap = uri.query(true);

export default {
    name: 'QueryFilter',

    components: {FilterButton},

    props: {
        name: {type: String, required: true},
        options: {type: Array, required: true},
        allOptionsLabel: {type: String, default: null},
        filterLabel: {type: String, default: null},
    },

    data() {
        const currentId = Number(queryMap[this.name]) || null;

        return {currentId};
    },

    computed: {
        action() {
            return uri.query(null).toString();
        },

        queries() {
            const queries = {...queryMap};
            delete queries[this.name];

            return queries;
        },

        allItemsLabel() {
            return this.allOptionsLabel || this.$t('common.placeholders.all');
        },

        actionLabel() {
            return this.filterLabel || this.$t('common.actions.filter');
        },
    },
};
</script>
